import { ConfigProvider, Layout, theme } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import UserRoutes from "../routes/userRoutes";
import WebFooter from "./components/navigation/webfooter";
import TopHeader from "./components/navigation/header";
import { useLocation } from "wouter";

const UserApp = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [location] = useLocation();
  const pathSegment = location.split("/")[1];
  const isLoginRoute = pathSegment === "login";
  return (
    <ConfigProvider
      theme={{
        token: {
          Layout: {
            headerPadding: 0,
          },
        },
      }}
    >
      <Layout className="min-h-screen">
        {!isLoginRoute && (
          <Header
            className="flex justify-between items-center text-lg px-0 h-min"
            style={{ background: colorBgContainer }}
          >
            <TopHeader />
          </Header>
        )}
        <Content className="bg-white rounded-xl my-auto">
          <UserRoutes />
        </Content>
        {!isLoginRoute && (
          <Footer className="p-0">
            <WebFooter />
          </Footer>
        )}
      </Layout>
    </ConfigProvider>
  );
};
export default UserApp;
